var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 85,
    viewBox: "0 0 83 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2203 84.0552C63.9857 84.0552 82.4407 65.2388 82.4407 42.0276C82.4407 18.8164 63.9857 0 41.2203 0C18.455 0 0 18.8164 0 42.0276C0 65.2388 18.455 84.0552 41.2203 84.0552Z",
    fill: "url(#paint0_linear_1123_567)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2206 70.6207C56.7088 70.6207 69.2644 57.8192 69.2644 42.0277C69.2644 26.2361 56.7088 13.4346 41.2206 13.4346C25.7324 13.4346 13.1768 26.2361 13.1768 42.0277C13.1768 57.8192 25.7324 70.6207 41.2206 70.6207Z",
    fill: "url(#paint1_linear_1123_567)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4407 36.4549H30.5344V35.7986L32.9159 32.2264C32.9908 32.1141 33.0923 32.0219 33.2114 31.9582C33.3304 31.8945 33.4634 31.8611 33.5985 31.8611H36.4407V36.4549Z",
    fill: "#FA5D3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4407 46.9549V43.0174H24.3C23.8649 43.0174 23.4476 43.1902 23.14 43.4979C22.8323 43.8056 22.6594 44.2229 22.6594 44.658V52.6971C22.6594 52.9146 22.7458 53.1233 22.8997 53.2771C23.0535 53.431 23.2622 53.5174 23.4797 53.5174H59.9016C60.1192 53.5174 60.3278 53.431 60.4817 53.2771C60.6355 53.1233 60.7219 52.9146 60.7219 52.6971V46.9549H36.4407Z",
    fill: "#FA5D3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4407 43.6736H23.9719V43.0174L28.4849 36.8121C28.7132 36.4982 29.0125 36.2428 29.3584 36.0666C29.7043 35.8905 30.087 35.7986 30.4751 35.7986H36.4407V43.6736Z",
    fill: "#FEECE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6047 29.2361H59.9016C60.1192 29.2361 60.3278 29.3226 60.4817 29.4764C60.6355 29.6302 60.7219 29.8389 60.7219 30.0565V47.6111H35.7844V30.0565C35.7844 29.8389 35.8708 29.6302 36.0247 29.4764C36.1785 29.3226 36.3872 29.2361 36.6047 29.2361V29.2361Z",
    fill: "#FAC850"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2219 58.7674C31.3965 58.7674 33.1594 57.0045 33.1594 54.8299C33.1594 52.6553 31.3965 50.8924 29.2219 50.8924C27.0473 50.8924 25.2844 52.6553 25.2844 54.8299C25.2844 57.0045 27.0473 58.7674 29.2219 58.7674Z",
    fill: "#4D4D4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1594 58.7674C56.334 58.7674 58.0969 57.0045 58.0969 54.8299C58.0969 52.6553 56.334 50.8924 54.1594 50.8924C51.9848 50.8924 50.2219 52.6553 50.2219 54.8299C50.2219 57.0045 51.9848 58.7674 54.1594 58.7674Z",
    fill: "#4D4D4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1907 44.9861H33.8157V46.2986H31.1907V44.9861Z",
    fill: "#FFFEFD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 48.2674H22.6594V44.658C22.6594 44.2229 22.8323 43.8056 23.14 43.4979C23.4476 43.1902 23.8649 43.0174 24.3 43.0174H25.9407V46.6268C25.9407 47.0619 25.7678 47.4792 25.4601 47.7869C25.1525 48.0945 24.7352 48.2674 24.3 48.2674Z",
    fill: "#FAC850"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.836 43.9325C44.748 42.4115 43.3231 40.1476 42.8549 37.6073L42.3633 34.4862L48.2613 31.8562L54.1594 34.4862L53.6627 37.6333C53.1906 40.1953 51.7453 42.4753 49.6297 43.9955L48.2666 44.9862L46.836 43.9325Z",
    fill: "#9FDC6E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5975 40.3924C47.5113 40.3925 47.426 40.3756 47.3463 40.3426C47.2667 40.3096 47.1944 40.2612 47.1335 40.2001L45.1648 38.2314L46.0928 37.3033L47.5975 38.808L51.071 35.3346L51.9991 36.2626L48.0616 40.2001C48.0007 40.2612 47.9284 40.3096 47.8487 40.3426C47.7691 40.3756 47.6837 40.3925 47.5975 40.3924V40.3924Z",
    fill: "#FBFEF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7532 31.2049H39.0657V32.5174H37.7532V31.2049Z",
    fill: "#FFFAF6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7532 44.3299H39.0657V45.6424H37.7532V44.3299Z",
    fill: "#FFFAF6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4407 31.2049H58.7532V32.5174H57.4407V31.2049Z",
    fill: "#FFFAF6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4407 44.3299H58.7532V45.6424H57.4407V44.3299Z",
    fill: "#FFFAF6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2219 56.1424C29.9468 56.1424 30.5344 55.5548 30.5344 54.8299C30.5344 54.105 29.9468 53.5174 29.2219 53.5174C28.4971 53.5174 27.9094 54.105 27.9094 54.8299C27.9094 55.5548 28.4971 56.1424 29.2219 56.1424Z",
    fill: "#FEFEFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1594 56.1424C54.8843 56.1424 55.4719 55.5548 55.4719 54.8299C55.4719 54.105 54.8843 53.5174 54.1594 53.5174C53.4346 53.5174 52.8469 54.105 52.8469 54.8299C52.8469 55.5548 53.4346 56.1424 54.1594 56.1424Z",
    fill: "#FEFEFE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0032 31.2049H27.2532V32.5174H22.0032V31.2049Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5657 31.2049H29.8782V32.5174H28.5657V31.2049Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9094 24.6424H38.4094V25.9549H27.9094V24.6424Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7219 24.6424H41.0344V25.9549H39.7219V24.6424Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6282 25.9549H56.1282V27.2674H45.6282V25.9549Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4407 25.9549H58.7532V27.2674H57.4407V25.9549Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4719 56.7986H46.2844V58.1111H34.4719V56.7986Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5969 56.7986H48.9094V58.1111H47.5969V56.7986Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1123_567",
    x1: 8.49139,
    y1: -30.2599,
    x2: 119.476,
    y2: 205.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1123_567",
    x1: -2.35953,
    y1: -80.3506,
    x2: 57.0719,
    y2: 80.1172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7F20"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.55393d507a4633613df6cb5ea45abc02.svg";
export { ForwardRef as ReactComponent };